import Header from '@components/layout/header';
import useTeams from '@hooks/useTeams';
import { Box, CircularProgress, Grid2 as Grid, Typography } from '@mui/material';
import RichTextEditor from '@molecules/RichTextEditor';

export default function TeamOverview() {
    const { loading, selectedTeam } = useTeams();

    return (
        <>
            <Header pageTitle={'Team Overview'} />
            <Box padding={2}>
                {loading ? (
                    <Grid marginX={'50%'} paddingY={'20%'}>
                        <CircularProgress color="secondary" size={40} />
                    </Grid>
                ) : (
                    <Grid container spacing={2}>
                        {selectedTeam?.name ? (
                            <Grid size={3}>
                                <Typography variant="h6" gutterBottom>
                                    Team Name
                                </Typography>
                                <Typography>{selectedTeam?.name}</Typography>
                            </Grid>
                        ) : null}

                        {selectedTeam?.teamImageUrl ? (
                            <Grid size={3}>
                                <img
                                    src={selectedTeam?.teamImageUrl}
                                    alt={'Team Image'}
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Grid>
                        ) : null}

                        <Grid size={3}>
                            <Typography variant="h6" gutterBottom>
                                Description
                            </Typography>
                            <Typography>{selectedTeam?.description}</Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography variant="h6" gutterBottom>
                                Joining Fee
                            </Typography>
                            <Typography>{selectedTeam?.fee}</Typography>
                        </Grid>

                        {selectedTeam?.codeOfConduct ? (
                            <Grid size={10}>
                                <Typography variant="h6" gutterBottom>
                                    Code of Conduct
                                </Typography>

                                <RichTextEditor data={selectedTeam?.codeOfConduct} />
                            </Grid>
                        ) : null}
                    </Grid>
                )}
            </Box>
        </>
    );
}
